import React, { memo } from 'react'

import { func, oneOf, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import Modal from 'Pods/Shared/Modal/Modal'

import AuthFlow from './AuthFlow'
import { MODE, STEP } from './constants'

function AuthModal({
  mode = MODE.SIGNUP,
  initialStep = STEP.AUTH,
  locale = 'en',
  onClose: handleClose,
}) {
  const ariaLabelKey = mode === MODE.LOGIN ? 'login' : 'signup'

  return (
    <Modal
      isOpen
      width="large"
      customClass="auth-modal"
      ariaLabel={i18n.t(`auth_modal.aria_label.${ariaLabelKey}`, { ns: 'rails', lng: locale })}
      onClose={handleClose}
    >
      <AuthFlow mode={mode} initialStep={initialStep} locale={locale} />
    </Modal>
  )
}

AuthModal.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]),
  initialStep: oneOf([STEP.AUTH, STEP.CODE, STEP.PASSWORD, STEP.SUCCESS]),
  locale: string,
  onClose: func.isRequired,
}

export default memo(AuthModal)
